module.exports = __webpack_public_path__ + "img/slider_9.7292ec95.jpg";